/* WordyPaws theme JS: loader, reveals, clock, menu, demo buttons, counters, variant sync */
(function () {
  "use strict";
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* Loader (index only) */
  var loader = document.getElementById("loader");
  function heroReveal() {
    var hdr = document.getElementById("hdr");
    if (hdr) hdr.classList.add("in");
    ["wm", "statusbar", "boardwrap", "trusted"].forEach(function (id, i) {
      var el = document.getElementById(id);
      if (el) setTimeout(function () { el.classList.add("in"); }, 300 + i * 200);
    });
    document.querySelectorAll(".hl").forEach(function (el) { el.classList.add("in"); });
    document.querySelectorAll(".hrv").forEach(function (el, i) {
      setTimeout(function () { el.classList.add("in"); }, 350 + i * 150);
    });
  }
  if (loader) {
    var fill = document.getElementById("lfill");
    var count = document.getElementById("lcount");
    var FILL = reduced ? 0 : 1300;
    var t0 = performance.now();
    var ease = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
    (function tick(now) {
      var t = FILL === 0 ? 1 : Math.min((now - t0) / FILL, 1);
      var p = Math.round(ease(t) * 100);
      if (fill) fill.style.width = p + "%";
      if (count) count.textContent = String(p).padStart(3, "0");
      if (t < 1) requestAnimationFrame(tick);
      else {
        loader.classList.add("exit");
        setTimeout(function () { loader.remove(); heroReveal(); }, reduced ? 0 : 760);
      }
    })(t0);
  }

  /* Scroll reveals */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      if (el.classList.contains("words")) {
        el.querySelectorAll(".w").forEach(function (w, i) { w.style.transitionDelay = i * 35 + "ms"; });
      }
      setTimeout(function () { el.classList.add("in"); }, Number(el.dataset.d || 0));
      io.unobserve(el);
    });
  }, { threshold: 0.15 });
  var st = document.getElementById("statement");
  if (st) {
    (function split(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var frag = document.createDocumentFragment();
          n.textContent.split(/\s+/).filter(Boolean).forEach(function (word) {
            var s = document.createElement("span");
            s.className = node.classList && node.classList.contains("mut") ? "w mut" : "w";
            s.textContent = word;
            frag.appendChild(s);
            frag.appendChild(document.createTextNode(" "));
          });
          node.replaceChild(frag, n);
        } else if (n.nodeType === 1) split(n);
      });
    })(st);
  }
  document.querySelectorAll(".io").forEach(function (el) { io.observe(el); });

  /* Clock */
  var ct = document.getElementById("clock-t");
  var cd = document.getElementById("clock-d");
  if (ct) {
    var months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    var tickClock = function () {
      var d = new Date();
      var h = d.getHours() % 12 || 12;
      var m = String(d.getMinutes()).padStart(2, "0");
      ct.textContent = h + ":" + m + (d.getHours() < 12 ? "am" : "pm");
      if (cd) cd.textContent = d.getDate() + " " + months[d.getMonth()] + ", " + d.getFullYear();
    };
    tickClock();
    setInterval(tickClock, 1000);
  }

  /* Menu overlay */
  var navm = document.getElementById("navmenu");
  var openBtn = document.getElementById("openmenu");
  var closeBtn = document.getElementById("closemenu");
  function closeMenu() {
    if (!navm || !navm.classList.contains("open")) return;
    navm.classList.remove("vis");
    setTimeout(function () { navm.classList.remove("open"); }, 450);
    document.documentElement.style.removeProperty("overflow");
  }
  if (openBtn && navm) {
    openBtn.addEventListener("click", function () {
      navm.classList.add("open");
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        navm.classList.add("vis");
        navm.querySelectorAll("nav li").forEach(function (li, i) { li.style.transitionDelay = i * 45 + 80 + "ms"; });
      }); });
      document.documentElement.style.overflow = "hidden";
    });
  }
  if (closeBtn) closeBtn.addEventListener("click", closeMenu);
  window.addEventListener("keydown", function (e) { if (e.key === "Escape") closeMenu(); });
  document.querySelectorAll("[data-goto]").forEach(function (b) {
    b.addEventListener("click", function () {
      closeMenu();
      var el = document.getElementById(b.dataset.goto);
      if (el) setTimeout(function () { el.scrollIntoView({ behavior: reduced ? "auto" : "smooth" }); }, 60);
    });
  });

  /* Demo talking buttons */
  var actx = null;
  function chirp(f) {
    try {
      actx = actx || new (window.AudioContext || window.webkitAudioContext)();
      var o = actx.createOscillator();
      var g = actx.createGain();
      o.type = "sine";
      o.frequency.setValueAtTime(f, actx.currentTime);
      o.frequency.exponentialRampToValueAtTime(f * 1.5, actx.currentTime + 0.12);
      g.gain.setValueAtTime(0.001, actx.currentTime);
      g.gain.exponentialRampToValueAtTime(0.15, actx.currentTime + 0.02);
      g.gain.exponentialRampToValueAtTime(0.001, actx.currentTime + 0.25);
      o.connect(g).connect(actx.destination);
      o.start();
      o.stop(actx.currentTime + 0.3);
    } catch (e) { /* audio unavailable; bubble still answers */ }
  }
  var bubble = document.getElementById("bubble");
  var bubT = null;
  document.querySelectorAll(".dogbtn").forEach(function (b) {
    b.addEventListener("click", function () {
      chirp(Number(b.dataset.f));
      if (!bubble) return;
      bubble.textContent = b.dataset.word;
      bubble.classList.add("show");
      clearTimeout(bubT);
      bubT = setTimeout(function () { bubble.classList.remove("show"); }, 1400);
    });
  });

  /* Stat counters */
  var grid = document.getElementById("statgrid");
  if (grid) {
    var counters = grid.querySelectorAll("[data-count]");
    var last = 0;
    var update = function () {
      var now = performance.now();
      if (now - last < 30) return;
      last = now;
      var r = grid.getBoundingClientRect();
      var vh = window.innerHeight;
      var prog = Math.min(Math.max((vh - r.top) / (vh - (vh / 2 - r.height / 2)), 0), 1);
      counters.forEach(function (c) { c.textContent = Math.round(prog * Number(c.dataset.count)); });
    };
    window.addEventListener("scroll", update, { passive: true });
    update();
  }

  /* Variant sync: swap image + price when color changes */
  function wireSelect(selectId, imgId, priceId) {
    var sel = document.getElementById(selectId);
    var img = document.getElementById(imgId);
    if (!sel) return;
    sel.addEventListener("change", function () {
      var opt = sel.options[sel.selectedIndex];
      if (img && opt.dataset.img) img.src = opt.dataset.img;
      var price = document.getElementById(priceId || "");
      if (price && opt.dataset.price) price.textContent = opt.dataset.price;
    });
  }
  wireSelect("landing-select", "landing-img", null);
  wireSelect("pdp-select", "pdp-img", "pdp-price");

  /* Product thumbs */
  document.querySelectorAll(".pdp-thumb").forEach(function (t) {
    t.addEventListener("click", function () {
      var img = document.getElementById("pdp-img");
      if (img) img.src = t.dataset.src;
    });
  });
})();
